<template>
  <span>
    <span class="font-semibold">{{ params.data.countriesCount }} </span> {{ params.data.countriesCount > 1 ? 'Countries' : 'Country' }}
  </span>
</template>


<script>
export default {

}
</script>
